import { makeOpsEventURL } from "../../utils/URL-ops/make-ops-event-URL.js";
import { makeOpsReportURL } from "../../utils/URL-ops/make-ops-report-URL.js";
import { makeProfileNotificationURL } from "../../utils/URL-profile/make-profile-notification-URL.js";
import { RPCDocs } from "../../services/rpc.js";
// src/modules/Notifications/get-notification-destination.ts
var EntityType = RPCDocs.Notifications.FindMyNotifications.v1.EntityType;
/**
* Where a notification navigates: explicit link → sourceRef mapping →
* inbox deep link. sourceRef.entityType is a closed union — the default
* branch keeps forward-compat when the backend adds entity types.
*/
function getNotificationDestination(item) {
	if (item.link) return item.link;
	if (item.sourceRef) switch (item.sourceRef.entityType) {
		case EntityType.Event: return makeOpsEventURL(item.sourceRef.entityId);
		case EntityType.Report: return makeOpsReportURL(item.sourceRef.entityId);
	}
	return makeProfileNotificationURL(item.notificationId);
}
export { getNotificationDestination };

//# sourceMappingURL=get-notification-destination.js.map